import { render } from "./MiListItemSection.vue?vue&type=template&id=171cfcd2&scoped=true"
import script from "./MiListItemSection.vue?vue&type=script&lang=js"
export * from "./MiListItemSection.vue?vue&type=script&lang=js"

import "./MiListItemSection.vue?vue&type=style&index=0&id=171cfcd2&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171cfcd2"]])

export default __exports__
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItemSection,QItem,QIcon});
